import tenantsService from '../services/tenants';
import useAsyncList from './useAsyncList';

/**
 * Active tenants of an app, for pickers and id -> name lookups.
 * @param {string} appId
 * @param {{ enabled?: boolean }} [opts] pass enabled=false to skip (e.g. single-tenant apps)
 * @returns {{ items: object[], byId: Record<string, object>, loading: boolean, error: string, reload: () => void }}
 */
export default function useTenants(appId, { enabled = true } = {}) {
    return useAsyncList(() => tenantsService.getAll(appId), {
        key: appId || '',
        enabled,
        idKey: 'tenant_id',
        errorMessage: 'Couldn’t load tenants for this app.',
    });
}
